import { render } from "./TangentCalculator.vue?vue&type=template&id=493176c5"
import script from "./TangentCalculator.vue?vue&type=script&lang=js"
export * from "./TangentCalculator.vue?vue&type=script&lang=js"

import "./TangentCalculator.vue?vue&type=style&index=0&id=493176c5&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__